export default function Footer() {
  return (
    <footer className="bg-gray-100 border-t mt-10">
      <div className="max-w-7xl mx-auto px-6 py-10 text-gray-700">

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center sm:text-left">

          {/* BRAND */}
          <div>
            <h2 className="text-xl font-bold">Dimpex Jewellery</h2>
            <p className="mt-2 text-sm">
              Premium 92.5 Sterling Silver jewellery crafted with elegance.
            </p>

            {/* SOCIAL ICONS */}
            <div className="flex justify-center sm:justify-start gap-4 mt-4 text-xl">
              <a href="#" className="hover:text-indigo-600">📸</a>
              <a href="#" className="hover:text-indigo-600">📘</a>
              <a href="#" className="hover:text-indigo-600">🎬</a>
              <a href="#" className="hover:text-indigo-600">🐦</a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-indigo-600">Home</a></li>
              <li><a href="#" className="hover:text-indigo-600">Shop</a></li>
              <li><a href="#" className="hover:text-indigo-600">Favourites</a></li>
              <li><a href="#" className="hover:text-indigo-600">Cart</a></li>
            </ul>
          </div>

          {/* SUPPORT */}
          <div>
            <h3 className="font-semibold mb-3">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-indigo-600">Refund Policy</a></li>
              <li><a href="#" className="hover:text-indigo-600">Shipping Info</a></li>
              <li><a href="#" className="hover:text-indigo-600">Warranty</a></li>
              <li><a href="#" className="hover:text-indigo-600">Contact Us</a></li>
            </ul>
          </div>

        </div>

        {/* COPYRIGHT */}
        <div className="text-center text-sm text-gray-500 mt-10">
          © {new Date().getFullYear()} SilverStore — Crafted 92.5 Sterling Silver with Love
        </div>

      </div>
    </footer>
  );
}
